import { render, staticRenderFns } from "./SMSList.vue?vue&type=template&id=c91d84d0&scoped=true"
import script from "./SMSList.vue?vue&type=script&lang=js"
export * from "./SMSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91d84d0",
  null
  
)

export default component.exports